import { Plugin } from '@nuxt/types'
import { Vue } from 'nuxt-property-decorator'

export interface ErrorPagesPlugin {
  hideError: () => void
  showError: (code?: number) => void
  errorCode: number
}

const errorPages: Plugin = () => {
  const innerData = new Vue({
    data: {
      $errorPages: {
        errorCode: null,
      },
    },
  })

  function showError(code: number = 404) {
    innerData.$data.$errorPages.errorCode = code
  }
  function hideError() {
    innerData.$data.$errorPages.errorCode = null
  }

  Vue.mixin({
    computed: {
      $errorPages: {
        get() {
          return {
            errorCode: innerData.$data.$errorPages.errorCode,
            hideError,
            showError,
          }
        },
        set(newData) {
          innerData.$data.$errorPages.errorCode = newData
        },
      },
    },
  })
}

export default errorPages
